// KR_FORA(네이버 페이 스타일) antd 테마: 회색 캔버스 + 테두리 없는 흰 카드.
// 프라이머리 색은 바꾸지 않는다 (colorPrimary 미지정 → 기존 파랑 유지).
import { theme } from 'antd';

const FONT = "Pretendard, -apple-system, BlinkMacSystemFont, system-ui, Roboto, 'Helvetica Neue', 'Segoe UI', 'Apple SD Gothic Neo', 'Noto Sans KR', 'Malgun Gothic', sans-serif";

export const foraTheme = {
  token: {
    fontFamily: FONT,
    colorText: '#2e3238',
    colorTextSecondary: '#858a93',
    colorTextTertiary: '#a0a4ab',
    colorBorder: '#d5d8dd',
    colorBorderSecondary: '#e1e3e7',
    colorBgLayout: '#eceef1',
    colorBgContainer: '#f6f7f9',
    colorFillAlter: '#eaecef',
    colorFillSecondary: '#eaecef',
    colorError: '#f23d3d',
    borderRadius: 8,
    borderRadiusLG: 16,
    borderRadiusSM: 6,
    controlHeight: 36,
    fontWeightStrong: 700,
    boxShadow: '0 8px 24px rgb(0 0 0 / 0.08)',
    boxShadowSecondary: '0 8px 24px rgb(0 0 0 / 0.08)',
  },
  components: {
    Button: {
      fontWeight: 600,
      primaryShadow: 'none',
      defaultShadow: 'none',
      dangerShadow: 'none',
      borderRadiusLG: 10,
    },
    Table: {
      headerBg: '#eaecef',
      headerColor: '#858a93',
      headerSplitColor: 'transparent',
      rowHoverBg: '#f0f1f4',
      borderColor: '#e1e3e7',
    },
    Modal: {
      borderRadiusLG: 16,
      titleFontSize: 17,
    },
    Card: {
      borderRadiusLG: 16,
    },
    Tabs: {
      titleFontSize: 14,
    },
    Tag: {
      borderRadiusSM: 999,
    },
    // borderRadiusLG(16)는 모달·카드용. 큰 입력칸·버튼은 KR_FORA 처럼 10px
    Input: { borderRadiusLG: 10 },
    InputNumber: { borderRadiusLG: 10 },
    Select: { borderRadiusLG: 10 },
    DatePicker: { borderRadiusLG: 10 },
  },
};

// 라이트 바탕은 순백 대신 살짝 낮춘 흰색(index.css --card 와 같은 값)
// 다크: antd 다크 알고리즘 + palette.js 의 NEUTRAL_DARK 단계에 맞춘 바탕·글자·테두리
export const foraDarkTheme = {
  algorithm: theme.darkAlgorithm,
  token: {
    ...foraTheme.token,
    colorText: '#e4e6e9',
    colorTextSecondary: '#979ca5',
    colorTextTertiary: '#787d87',
    colorBorder: '#4b4f58',
    colorBorderSecondary: '#3c4048',
    colorBgLayout: '#1f2126',
    colorBgContainer: '#282a30',
    colorBgElevated: '#30333a',
    colorFillAlter: '#353840',
    colorFillSecondary: '#353840',
    boxShadow: '0 8px 24px rgb(0 0 0 / 0.4)',
    boxShadowSecondary: '0 8px 24px rgb(0 0 0 / 0.4)',
  },
  components: {
    ...foraTheme.components,
    Table: {
      ...foraTheme.components.Table,
      headerBg: '#353840',
      headerColor: '#979ca5',
      rowHoverBg: '#2f3238',
      borderColor: '#3c4048',
    },
  },
};
